// ============================================
// LIGA AJUPAM - React Query Provider
// ============================================

import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Configuración del QueryClient
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // staleTime corto para que el refetch on mount/reconnect realmente refresque.
      staleTime: 30 * 1000, // 30 segundos
      gcTime: 10 * 60 * 1000, // 10 minutos (antes cacheTime)
      retry: 1,
      // refetchOnWindowFocus: false (default a partir de jun 2026).
      // Cuando estaba en true, cada focus event disparaba refetch de TODAS las
      // queries cacheadas con stale > 30s. En sesiones admin con muchos managers
      // abiertos eso producia parpadeos visibles. El realtime cubre los cambios
      // criticos (matches, payments, teams), refetchOnMount cubre la navegacion,
      // y los botones "Actualizar" cubren el refresh manual cuando hace falta.
      //
      // Si una query especifica DEBE refetchear en focus (ej: contadores de
      // pendientes en headers), declarar `refetchOnWindowFocus: true` en su hook.
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,   // Refetch al recuperar la conexión
      refetchOnMount: true,
    },
    mutations: {
      retry: 0,
    },
  },
});

interface QueryProviderProps {
  children: React.ReactNode;
}

export const QueryProvider: React.FC<QueryProviderProps> = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
    </QueryClientProvider>
  );
};

export const useGlobalRefresh = () => {
  const refreshAllQueries = () => {
    queryClient.invalidateQueries();
  };
  return { refreshAllQueries };
};

export { queryClient };
